import { render, staticRenderFns } from "./Programacion.vue?vue&type=template&id=16e3068a&scoped=true"
import script from "./Programacion.vue?vue&type=script&lang=ts"
export * from "./Programacion.vue?vue&type=script&lang=ts"
import style0 from "./Programacion.vue?vue&type=style&index=0&id=16e3068a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e3068a",
  null
  
)

export default component.exports